export enum ClientsActionTypes {
    SET_CLIENTS = 'clients/setClients',
    LOAD_CLIENTS = 'clients/loadingClients',
    FILTER_CLIENTS_BY_VALUE = 'clients/filterClientsByValue',
    SORT_CLIENTS_BY_VALUE = 'clients/sortClientsByValue',
    RESET_CLIENTS = 'clients/resetClients'
}